import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
// ⚠ ONE seed, imported -- this module used to declare its own
// `getStartingCaseTypeListData` with the SAME ids bound to the OPPOSITE labels
// (XXCAT0001 as 'Address Change'). Nothing reconciled them, so which pairing a
// browser saw depended on how the store was filled: a cold start took this
// module's copy, while "Start Over" reseeds from api/msw/modules/mockData.ts,
// which has always used the entity one. The four seeded cases all embed
// { XXCAT0001, 'Service Down' }, so the entity file is the authority.
import { getStartingCaseTypeListData } from '../../caseTypes/mockData'
import type { ICaseType } from '~/types/case/models'
import type { TEntityId, ISelectItem } from '~/types/models'

const caseTypeListData = undefined as unknown as ICaseType[]

export const getCaseTypeListData = getListDataFunctionFactory<ICaseType[]>({
  listData: caseTypeListData,
  storageKey: 'casetypes',
  getStartingListData: getStartingCaseTypeListData,
})

export function _getCATDataById(id: TEntityId, list: ICaseType[]): ICaseType {
  if (!list) {
    throw new Error(`_getCATDataById called with undefined/falsey list`)
  }
  const caseType = list.find((lt: ICaseType) => lt.id === id)
  if (!caseType) {
    throw new Error(`Can't find caseType '${id}'`)
  }
  return caseType
}

export function _getCATSelectItemDataByLabel(
  label: string,
  list: ICaseType[]
): ISelectItem {
  if (!list) {
    throw new Error(`_getCATDataById called with undefined/falsey list`)
  }
  const caseType = list.find((lt) => lt.descr === label)
  if (!caseType) {
    throw new Error(`Can't find caseType '${label}'`)
  }
  return { id: caseType.id, label: caseType.descr }
}

export async function getCaseTypeDataById(id: TEntityId): Promise<ICaseType> {
  const list: ICaseType[] = await getCaseTypeListData()
  return _getCATDataById(id, list)
}

export async function getCaseTypeDataByLabel(
  label: string
): Promise<ICaseType> {
  const list: ICaseType[] = await getCaseTypeListData()
  if (!list) {
    throw new Error(`getCaseTypeListData returned undefined/null`)
  }
  const lt = list.find((caseType) => caseType.label === label)
  if (!lt) {
    throw new Error(`Can't find caseType '${label}'`)
  }
  return lt
}

export async function getCaseTypeSelectItemDataByLabel(
  label: string
): Promise<ISelectItem> {
  const list: ICaseType[] = await getCaseTypeListData()
  return _getCATSelectItemDataByLabel(label, list)
}
